import { useMemorama } from '../../context/MemoramaContext'
import { BOARD_SIZES, CARDS_PER_SIZE } from '../../constants/memorama'
import { useLanguage } from '@context/LanguageContext'
import { useRovingTabIndex } from '@hooks/useRovingTabIndex'
import { cx } from '@utils/cx'
import styles from './BoardSizeSelector.module.css'

function BoardSizeSelector () {
  const { boardSize, setBoardSize } = useMemorama()
  const { t } = useLanguage()
  const { getTabIndex, getItemRef, handleKeyDown } = useRovingTabIndex({
    itemCount: BOARD_SIZES.length,
    navigationStrategy: 'linear',
    onActivate: (index) => {
      const selectedSize = BOARD_SIZES[index]
      setBoardSize(selectedSize)
    }
  })

  return (
    <div className={styles.boardSizeSelector}>
      <h2 id='board-size-heading' className={styles.label}>
        {t.memorama.board.label}
      </h2>
      <div
        className={styles.options}
        role='radiogroup'
        aria-labelledby='board-size-heading'
        onKeyDown={handleKeyDown}
      >
        {BOARD_SIZES.map((size, index) => (
          <button
            key={size}
            ref={getItemRef(index)}
            tabIndex={getTabIndex(index)}
            type='button'
            role='radio'
            aria-checked={boardSize === size}
            aria-label={t.memorama.access.board.size.replace('{size}', size.toUpperCase())}
            title={t.memorama.board.tooltip.replace('{count}', CARDS_PER_SIZE[size])}
            className={cx(
              styles.option,
              boardSize === size && styles.optionActive
            )}
            onClick={() => setBoardSize(size)}
          >
            {size.toUpperCase()}
          </button>
        ))}
      </div>
    </div>
  )
}

export default BoardSizeSelector
